@if (fields.length > 0) {
<section outline>
  <h2>Custom fields</h2>
  @for (field of fields; track field) {
  <p>
    {{ field.config.name }}: {{ field.value }}
    @if (field.value == null) {
    <empty>no data added</empty>
    }
  </p>
  }
</section>
}
